// extracted by mini-css-extract-plugin
export default {"link":"SettingsButton_link__7H90p","notification":"SettingsButton_notification__E0NWB","icon":"SettingsButton_icon__3S8pD"};